import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import ReactDOMServer from 'react-dom/server';

import type {GetPlanComparisons_planComparisons_featureGroups_features as Feature} from 'nutshell-graphql-types';

import {PlanComparisonTableCell} from './plan-comparison-table-cell';

import styles from './plan-comparison-table.module.css';

type Props = {
    feature: Feature;
};

// Normal table row, contains the feature name as the far left column
// and the feature availability for each plan (checkmark, text, etc.)
export function PlanComparisonTableRow(props: Props): React.ReactElement {
    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, []);

    return (
        <tr className={styles['table-row--feature']}>
            {/* Attaching the tooltip to the cell so it doesn't get cut off */}
            {/* on the left side of the table */}
            <td className={styles['table-cell--feature-name']}>
                <span
                    data-html={Boolean(props.feature.tooltip)}
                    data-tip={
                        props.feature.tooltip
                            ? ReactDOMServer.renderToString(
                                  <div style={{width: 200, padding: 4, fontSize: 15}}>
                                      {props.feature.tooltip}
                                  </div>
                              )
                            : undefined
                    }
                    data-place='bottom'
                    className={styles['table-cell--feature-name-text']}
                >
                    {props.feature.name}
                </span>
            </td>
            {props.feature.planAvailabilities.map((planAvailability) => {
                return (
                    <td
                        key={planAvailability.crmTier}
                        className={styles['table-cell--feature-details']}
                    >
                        <PlanComparisonTableCell planAvailability={planAvailability} />
                    </td>
                );
            })}
        </tr>
    );
}
